export const ALL_ITEM_JEWELRYBOXES = [
  {
    categry: "jewelryBoxes",
    itemList: [
      {
        itemSelected: "ambra",
        itemName: "Ambra",
        itemDescription:
          "Ambra is a jewelry box set that comes with a translucent top which the materials can be customized to meet your needs.",
        itemDescriptionList:
        [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],      
          itemDesktopBig: [
          "/images/listItem/jewelryBoxes/Ambra/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Ambra-01.webp",
          "/images/listItem/jewelryBoxes/Ambra/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Ambra-02.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryBoxes/Ambra/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Ambra-01.webp",
          "/images/listItem/jewelryBoxes/Ambra/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Ambra-02.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryBoxes/Ambra/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Ambra-01.webp",
          "/images/listItem/jewelryBoxes/Ambra/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Ambra-02.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryBoxes/Ambra/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Ambra-01.webp",
          "/images/listItem/jewelryBoxes/Ambra/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Ambra-02.webp",
        ],
      },
      {
        itemSelected: "camilla",
        itemName: "Camilla",
        itemDescription:
          "Camilla is a gift box that can be customized in a beautiful and elegant way to present precious jewelry.",
          itemDescriptionList:
          [
            "Made in Thailand Craftsmanship",
            "Variety of World Class Materials",
            "Professional Consultation",
            "Fast Delivery",
          ],    
        itemDesktopBig: [
          "/images/listItem/jewelryBoxes/Camilla/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Camilla-01.webp",
          "/images/listItem/jewelryBoxes/Camilla/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Camilla-02.webp",
          "/images/listItem/jewelryBoxes/Camilla/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Camilla-03.webp",
          "/images/listItem/jewelryBoxes/Camilla/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Camilla-04.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryBoxes/Camilla/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Camilla-01.webp",
          "/images/listItem/jewelryBoxes/Camilla/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Camilla-02.webp",
          "/images/listItem/jewelryBoxes/Camilla/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Camilla-03.webp",
          "/images/listItem/jewelryBoxes/Camilla/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Camilla-04.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryBoxes/Camilla/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Camilla-01.webp",
          "/images/listItem/jewelryBoxes/Camilla/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Camilla-02.webp",
          "/images/listItem/jewelryBoxes/Camilla/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Camilla-03.webp",
          "/images/listItem/jewelryBoxes/Camilla/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Camilla-04.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryBoxes/Camilla/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Camilla-01.webp",
          "/images/listItem/jewelryBoxes/Camilla/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Camilla-02.webp",
          "/images/listItem/jewelryBoxes/Camilla/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Camilla-03.webp",
          "/images/listItem/jewelryBoxes/Camilla/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Camilla-04.webp",
        ],
      },
      {
        itemSelected: "daria",
        itemName: "Daria",
        itemDescription: "Daria is a jewelry box that comes with a velvet interior to add a touch of sophistication to your precious jewelry.",
        itemDescriptionList:
        [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ], 
        itemDesktopBig: [
          "/images/listItem/jewelryBoxes/Daria/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Daria-01.webp",
          "/images/listItem/jewelryBoxes/Daria/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Daria-02.webp",
          "/images/listItem/jewelryBoxes/Daria/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Daria-03.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryBoxes/Daria/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Daria-01.webp",
          "/images/listItem/jewelryBoxes/Daria/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Daria-02.webp",
          "/images/listItem/jewelryBoxes/Daria/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Daria-03.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryBoxes/Daria/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Daria-01.webp",
          "/images/listItem/jewelryBoxes/Daria/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Daria-02.webp",
          "/images/listItem/jewelryBoxes/Daria/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Daria-03.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryBoxes/Daria/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Daria-01.webp",
          "/images/listItem/jewelryBoxes/Daria/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Daria-02.webp",
          "/images/listItem/jewelryBoxes/Daria/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Daria-03.webp",
        ],
      },
      {
        itemSelected: "elena",
        itemName: "Elena",
        itemDescription: "Elena is a jewelry box set which can be customized to meet your needs. It comes in a variety of sizes to handle all kinds of jewelry.",
        itemDescriptionList:
        [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ], 
        itemDesktopBig: [
          "/images/listItem/jewelryBoxes/Elena/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Elena-01.webp",
          "/images/listItem/jewelryBoxes/Elena/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Elena-02.webp",
          "/images/listItem/jewelryBoxes/Elena/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Elena-03.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryBoxes/Elena/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Elena-01.webp",
          "/images/listItem/jewelryBoxes/Elena/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Elena-02.webp",
          "/images/listItem/jewelryBoxes/Elena/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Elena-03.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryBoxes/Elena/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Elena-01.webp",
          "/images/listItem/jewelryBoxes/Elena/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Elena-02.webp",
          "/images/listItem/jewelryBoxes/Elena/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Elena-03.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryBoxes/Elena/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Elena-01.webp",
          "/images/listItem/jewelryBoxes/Elena/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Elena-02.webp",
          "/images/listItem/jewelryBoxes/Elena/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Elena-03.webp",
        ],
      },
      {
        itemSelected: "eleonora",
        itemName: "Eleonora",
        itemDescription: "Eleonora is a jewelry box set that can be personalized to your preferences. Whether it is velvet, PU, paper, or other available materials, we can customize it for our customers.",
        itemDescriptionList:
        [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ], 
        itemDesktopBig: [
          "/images/listItem/jewelryBoxes/Eleonora/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Eleonora.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryBoxes/Eleonora/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Eleonora.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryBoxes/Eleonora/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Eleonora.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryBoxes/Eleonora/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Eleonora.webp",
        ],
      },
      {
        itemSelected: "serena",
        itemName: "Serena",
        itemDescription: "Serena is a square shaped jewelry box set which can be customized to meet your needs.",
        itemDescriptionList:
        [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ], 
        itemDesktopBig: [
          "/images/listItem/jewelryBoxes/Serena/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Serena-01.webp",
          "/images/listItem/jewelryBoxes/Serena/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Serena-02.webp",
          "/images/listItem/jewelryBoxes/Serena/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Serena-03.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryBoxes/Serena/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Serena-01.webp",
          "/images/listItem/jewelryBoxes/Serena/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Serena-02.webp",
          "/images/listItem/jewelryBoxes/Serena/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Serena-03.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryBoxes/Serena/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Serena-01.webp",
          "/images/listItem/jewelryBoxes/Serena/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Serena-02.webp",
          "/images/listItem/jewelryBoxes/Serena/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Serena-03.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryBoxes/Serena/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Serena-01.webp",
          "/images/listItem/jewelryBoxes/Serena/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Serena-02.webp",
          "/images/listItem/jewelryBoxes/Serena/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Serena-03.webp",
        ],
      },
      {
        itemSelected: "stella",
        itemName: "Stella",
        itemDescription: "Stella is an octagonal shaped jewelry box set that can be personalized to your preferences.",
        itemDescriptionList:
        [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ], 
        itemDesktopBig: [
          "/images/listItem/jewelryBoxes/Stella/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Stella-01.webp",
          "/images/listItem/jewelryBoxes/Stella/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Stella-02.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryBoxes/Stella/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Stella-01.webp",
          "/images/listItem/jewelryBoxes/Stella/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Stella-02.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryBoxes/Stella/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Stella-01.webp",
          "/images/listItem/jewelryBoxes/Stella/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Stella-02.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryBoxes/Stella/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Stella-01.webp",
          "/images/listItem/jewelryBoxes/Stella/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Stella-02.webp",
        ],
      },
      {
        itemSelected: "valentina",
        itemName: "Valentina",
        itemDescription: "Valentina is a jewelry box set that can be customized to meet your needs. It comes in a variety of sizes to handle all kinds of jewelry.",
        itemDescriptionList:
        [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],      
        itemDesktopBig: [
          "/images/listItem/jewelryBoxes/Valentina/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Valentina-01.webp",
          "/images/listItem/jewelryBoxes/Valentina/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Valentina-02.webp",
          "/images/listItem/jewelryBoxes/Valentina/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Valentina-03.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryBoxes/Valentina/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Valentina-01.webp",
          "/images/listItem/jewelryBoxes/Valentina/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Valentina-02.webp",
          "/images/listItem/jewelryBoxes/Valentina/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Valentina-03.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryBoxes/Valentina/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Valentina-01.webp",
          "/images/listItem/jewelryBoxes/Valentina/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Valentina-02.webp",
          "/images/listItem/jewelryBoxes/Valentina/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Valentina-03.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryBoxes/Valentina/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Valentina-01.webp",
          "/images/listItem/jewelryBoxes/Valentina/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Valentina-02.webp",
          "/images/listItem/jewelryBoxes/Valentina/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Valentina-03.webp",
        ],
      },
      {
        itemSelected: "vittoria",
        itemName: "Vittoria",
        itemDescription: "Vittoria is a jewelry box set that comes with a combination of two distinct materials. Customers can still choose the kind of materials that they want this set to be. ",
        itemDescriptionList:
        [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],    
        itemDesktopBig: [
          "/images/listItem/jewelryBoxes/Vittoria/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Vittoria-01.webp",
          "/images/listItem/jewelryBoxes/Vittoria/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Vittoria-02.webp",
          "/images/listItem/jewelryBoxes/Vittoria/Desktop/700x700px/Lussopack-Packaging-Jewelry-Boxes-Vittoria-03.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryBoxes/Vittoria/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Vittoria-01.webp",
          "/images/listItem/jewelryBoxes/Vittoria/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Vittoria-02.webp",
          "/images/listItem/jewelryBoxes/Vittoria/Desktop/130x130px/Lussopack-Packaging-Jewelry-Boxes-Vittoria-03.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryBoxes/Vittoria/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Vittoria-01.webp",
          "/images/listItem/jewelryBoxes/Vittoria/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Vittoria-02.webp",
          "/images/listItem/jewelryBoxes/Vittoria/Mobile/335x335px/Lussopack-Packaging-Jewelry-Boxes-Vittoria-03.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryBoxes/Vittoria/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Vittoria-01.webp",
          "/images/listItem/jewelryBoxes/Vittoria/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Vittoria-02.webp",
          "/images/listItem/jewelryBoxes/Vittoria/Mobile/100x100px/Lussopack-Packaging-Jewelry-Boxes-Vittoria-03.webp",
        ],
      },
    ],
  },
];
